import React, { useContext, useEffect } from 'react';
import { RingLoader } from "react-spinners";
// import { toast } from 'react-toastify';
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import Dashboard from '../pages/Dashboard';
import { AuthContext } from '../context/AuthContext';
import ProductList from '../pages/products/ProductList';
import ProductDetails from '../pages/products/ProductDetails';
import GroupsList from '../pages/groups/GroupsList';
import VendorPage from '../pages/vendors/VendorPage';
import VendorDetail from '../pages/vendors/VendorDetail';
import BrokerPage from '../pages/brokers/BrokersList';
import BrokerDetail from '../pages/brokers/BrokerDetail';
import BuyerPage from '../pages/buyers/BuyerPage';
import BuyerDetail from '../pages/buyers/BuyerDetail';
import StaffList from '../pages/staff/StaffList';
import StaffRoles from '../pages/staff/StaffRoles';
import StaffDetail from '../pages/staff/StaffDetail';
import AllPurchaseRequests from '../pages/purchaseRequests/AllPurchaseRequests';
import PurchaseRequestDetails from '../pages/purchaseRequests/PurchaseRequestDetails';
// import RFQEditPage from '../components/purchaseRequests/RFQ/RFQEditPage';
import RFQCreatePage from '../components/purchaseRequests/RFQ/RFQCreatePage';
import RfqDetails from '../pages/purchaseRequests/RfqDetails';
import PurchaseRequestManagement from '../pages/PurchaseRequestManagement';
import RFQManagement from '../pages/RFQManagement';

import WarehouseLocationTree from '../components/warehouses/WarehouseLocationTree';

import PurchaseOrderList from '../pages/purchaseOrders/PurchaseOrderList';
import ApprovedQuotations from '../pages/purchaseOrders/ApprovedQuotations';
import PurchaseOrderDetails from '../pages/purchaseOrders/PurchaseOrderDetails';
import AddPurchaseOrder from '../pages/purchaseOrders/AddPurchaseOrder';
import AddQuotationPurchaseOrder from '../pages/purchaseOrders/AddQuotationPurchaseOrder';
import EditPurchaseOrder from '../pages/purchaseOrders/EditPurchaseOrder';

import SalesOrderList from '../pages/salesOrders/List';
import SalesOrderDetails from '../pages/salesOrders/SalesOrderDetails';
import CreateSalesOrder from "../pages/salesOrders/Create";
import CreateInHouseSalesOrder from "../pages/salesOrders/CreateInHouse";
import EditSalesOrder from '../pages/salesOrders/EditSalesOrder';
import PackagingMaterialPage from '../pages/packagingMaterial/packagingMaterialList';
import PackagingMaterialPOList from '../pages/packagingMaterial/packagingMaterialPOList';
import PackagingMaterialPODetails from '../pages/packagingMaterial/PackagingMaterialPODetails';
import PackagingMaterialStockDetails from '../pages/packagingMaterial/PackagingMaterialStockDetails';
import AddPackagingMaterialPO from '../pages/packagingMaterial/AddPackagingMaterialPO';
import EditPackagingMaterialPO from '../pages/packagingMaterial/EditPackagingMaterialPO';

import CreateBOM from '../pages/processingRecipe/CreateBOM';
import EditBOM from '../pages/processingRecipe/EditBOM';
import ProcessingRecipesList from '../pages/processingRecipe/BomList';
import ProcessingRecipeDetail from '../pages/processingRecipe/BomDetail';

import ProcessBatchList from '../pages/production/productionBatchesList';
import BatchDetailsPage from '../pages/production/BatchDetails';

import MachineList from '../pages/machinePlants/MachineList';
import MachineView from '../pages/machinePlants/MachineView';
import PlantList from '../pages/plants/PlantList';
import PlantView from '../pages/plants/PlantView';

import ProductionRequestWizard from '../pages/productionRequests/production_request_wizard_react';
import ProductionRequestList from '../pages/productionRequests/ProductionRequestList';
import ProductionRequestDetail from '../pages/productionRequests/ProductionRequestDetail';
import InventoryData from '../pages/inventory/InventoryList';
import InventoryDetail from '../pages/inventory/InventoryDetail';
import StockOverview from '../pages/stock/StockOverview';

import ProductStockDetails from '../pages/stock/ProductStockDetails';
import StockTransferInstanceList from '../pages/stock/StockTransferInstanceList';
import StockTransferInstanceCreate from '../pages/stock/StockTransferInstanceCreate';
import StockTransferInstanceDetails from '../pages/stock/StockTransferInstanceDetails';
import NewStockTransfer from '../pages/stock/NewStockTransfer';
import AddExistingStock from '../pages/stock/AddExistingStock';
import OperationsDashboard from './../pages/OperationsDashboard';
import SalesOrderDashboard from '../pages/SalesOrderDashboard';
import PackingOperations from '../pages/PackingOperations';
import NewPackingOperations from '../pages/NewPackingOperations';

import CompanySettings from '../components/settings/CompanySettings';
import InactiveStatus from '../pages/InactiveStatus';
import LabsPage from '../pages/labs/LabsPage';
import CollectorsPage from '../pages/collectors/CollectorsPage';
import Notifications from '../pages/Notifications';
import TransporterMaster from '../pages/master/TransporterMaster';
import VehicleMaster from '../pages/master/VehicleMaster';
import DriverMaster from '../pages/master/DriverMaster';
import TransporterDetails from '../pages/master/TransporterDetails';
import Reports from '../pages/Reports';
import ReportingDashboard from '../pages/ReportingDashboard';


const RequireAuth = ({ children, requiredPermissions = [] }) => {
  const {
    isAuthenticated,
    clientStatus,
    // loggedUser,
    // loading
  } = useContext(AuthContext);
  const location = useLocation();
  // const navigate = useNavigate();
  // const [hasPermissionError, setHasPermissionError] = useState(false); // State to track permission error

  // const userPermissions = loggedUser?.role?.permissions || [];
  // const isAdmin = loggedUser?.role?.name === 'Super Admin' || loggedUser?.role?.name === 'Admin';

  // // Check permissions only if requiredPermissions are specified and user is not admin
  // useEffect(() => {
  //   if (requiredPermissions.length > 0 && !isAdmin) {
  //     const hasAllRequiredPermissions = requiredPermissions.every(perm =>
  //       userPermissions.includes(perm)
  //     );
  //     if (!hasAllRequiredPermissions) {
  //       setHasPermissionError(true);
  //     } else {
  //       setHasPermissionError(false);
  //     }
  //   } else {
  //     setHasPermissionError(false); // No required permissions or user is admin
  //   }
  // }, [requiredPermissions, userPermissions, isAdmin]); // Dependencies for permission check

  // // Effect for redirection on permission error
  // useEffect(() => {
  //   if (hasPermissionError) {
  //     toast.error("Access Denied: You do not have the required permissions.");
  //     navigate('/dashboard', { replace: true });
  //   }
  // }, [hasPermissionError, navigate]); // Dependencies for redirection effect

  // // Effect for initial loading state
  // // This is intentionally placed before other checks to ensure loading spinner is always shown first
  // if (loading) {
  //   return (
  //     <div className="d-flex justify-content-center align-items-center position-relative" style={{ height: '100vh' }}>
  //       <RingLoader color="#014b7c" />
  //       <img src="/assets/img/icons/logo.png" alt="fms" className="position-absolute" style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '34px', height: '34px' }} />
  //     </div>
  //   );
  // }

  // Early return for client status and authentication
  if (clientStatus === 'inactive') {
    return <Navigate to="/inactive-status" replace />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // // Render nothing while redirecting due to permission error
  // if (hasPermissionError) {
  //   return null;
  // }

  return children;
};

const RoutesConfig = () => {
  const { isAuthenticated, loading, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  // Handle logout route
  useEffect(() => {
    if (window.location.pathname === '/logout') {
      logout();
      navigate('/', { replace: true });
    }
  }, [logout, navigate]);

  // Show loader while checking token
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center position-relative" style={{ height: '100vh' }}>
        <RingLoader color="#014b7c" />
        <img src="/assets/img/icons/logo.png" alt="fms" className="position-absolute" style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: '34px', height: '34px' }} />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <LoginForm />} />
      {/* <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} /> */}
      <Route path="/dashboard" element={<RequireAuth><OperationsDashboard /></RequireAuth>} />
      <Route path="/sales-dashboard" element={<RequireAuth><SalesOrderDashboard /></RequireAuth>} />
      {/* <Route path="/operations-dashboard" element={<RequireAuth><OperationsDashboard /></RequireAuth>} /> */}

      <Route path="/stats_dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/products" element={<RequireAuth><ProductList /></RequireAuth>} />
      <Route path="/products/:id" element={<RequireAuth><ProductDetails /></RequireAuth>} />
      <Route path="/groups" element={<RequireAuth><GroupsList /></RequireAuth>} />
      <Route path="/vendors" element={<RequireAuth><VendorPage /></RequireAuth>} />
      <Route path="/vendors/vendor_detail/:id" element={<RequireAuth><VendorDetail /></RequireAuth>} />
      <Route path="/brokers" element={<RequireAuth><BrokerPage /></RequireAuth>} />
      <Route path="/brokers/broker_detail/:id" element={<RequireAuth><BrokerDetail /></RequireAuth>} />
      <Route path="/buyers" element={<RequireAuth><BuyerPage /></RequireAuth>} />
      <Route path="/buyers/buyer_detail/:id" element={<RequireAuth><BuyerDetail /></RequireAuth>} />
      <Route path="/labs" element={<RequireAuth><LabsPage /></RequireAuth>} />
      <Route path="/collectors" element={<RequireAuth><CollectorsPage /></RequireAuth>} />
      {/* <Route path="/labs" element={<RequireAuth requiredPermissions={['lab_view']}><LabsPage /></RequireAuth>} />
      <Route path="/collectors" element={<RequireAuth requiredPermissions={['collector_view']}><CollectorsPage /></RequireAuth>} /> */}
      <Route path="/transporters" element={<RequireAuth><TransporterMaster /></RequireAuth>} />
      <Route path="/transporters/:transporterId" element={<RequireAuth><TransporterDetails /></RequireAuth>} />
      <Route path="/transporters/:transporterId/vehicles" element={<RequireAuth><VehicleMaster /></RequireAuth>} />
      <Route path="/transporters/:transporterId/drivers" element={<RequireAuth><DriverMaster /></RequireAuth>} />
      <Route path="/staff" element={<RequireAuth><StaffList /></RequireAuth>} />
      <Route path="/staff/:id" element={<RequireAuth><StaffDetail /></RequireAuth>} />
      <Route path="/staff/roles" element={<RequireAuth><StaffRoles /></RequireAuth>} />
      <Route path="/purchase_requests" element={<RequireAuth><AllPurchaseRequests /></RequireAuth>} />
      <Route path="/purchase_requests/:id" element={<RequireAuth><PurchaseRequestDetails /></RequireAuth>} />
      <Route path="/purchase-requests-management" element={<RequireAuth><PurchaseRequestManagement /></RequireAuth>} />

      {/* <Route path="/purchase-requests/:requestId/rfqs/:rfqId/edit" element={<RequireAuth><RFQEditPage /></RequireAuth>} /> */}

      <Route path="/new-rfq/:requestId/add" element={<RequireAuth><RFQCreatePage /></RequireAuth>} />
      <Route path="/rfq/:id" element={<RequireAuth><RfqDetails /></RequireAuth>} />
      <Route path="/rfqs" element={<RequireAuth><RFQManagement /></RequireAuth>} />
      <Route path="/rfqs/create" element={<RequireAuth><RFQCreatePage /></RequireAuth>} />
      <Route path="/rfqs/create-consolidated" element={<RequireAuth><RFQCreatePage /></RequireAuth>} />
      <Route path="/rfqs/:id" element={<RequireAuth><RfqDetails /></RequireAuth>} />
      <Route path="/rfqs/:id/edit" element={<RequireAuth><RFQCreatePage /></RequireAuth>} />


      <Route path="/warehouses" element={<RequireAuth><WarehouseLocationTree /></RequireAuth>} />

      <Route path="/purchase-orders" element={<RequireAuth><PurchaseOrderList /></RequireAuth>} />
      <Route path="/approved-quotations" element={<RequireAuth><ApprovedQuotations /></RequireAuth>} />
      <Route path="/purchase-orders/:id" element={<RequireAuth><PurchaseOrderDetails /></RequireAuth>} />
      <Route path="/new-purchase-order" element={<RequireAuth><AddPurchaseOrder /></RequireAuth>} />
      <Route path="/new-purchase-order/:id" element={<RequireAuth><AddQuotationPurchaseOrder /></RequireAuth>} />
      <Route path="/edit-purchase-order/:id" element={<RequireAuth><EditPurchaseOrder /></RequireAuth>} />

      <Route path="/sales-orders" element={<RequireAuth><SalesOrderList /></RequireAuth>} />
      <Route path="/sales-orders/create" element={<RequireAuth><CreateSalesOrder /></RequireAuth>} />
      <Route path="/sales-orders/create-in-house" element={<RequireAuth><CreateInHouseSalesOrder /></RequireAuth>} />
      <Route path="/sales-orders/:id" element={<RequireAuth><SalesOrderDetails /></RequireAuth>} />
      <Route path="/edit-sales-order/:id" element={<RequireAuth><EditSalesOrder /></RequireAuth>} />

      <Route path="/packaging-material" element={<RequireAuth><PackagingMaterialPage /></RequireAuth>} />
      <Route path="/packaging-material-purchase-orders" element={<RequireAuth><PackagingMaterialPOList /></RequireAuth>} />
      <Route path="/packaging-material-po/:id" element={<RequireAuth><PackagingMaterialPODetails /></RequireAuth>} />
      <Route path="/packaging-material-stock-details/:pmId" element={<RequireAuth><PackagingMaterialStockDetails /></RequireAuth>} />
      <Route path="/new-packaging-material-po" element={<RequireAuth><AddPackagingMaterialPO /></RequireAuth>} />
      <Route path="/edit-packaging-material-po/:id" element={<RequireAuth><EditPackagingMaterialPO /></RequireAuth>} />

      <Route path="/packing-operations" element={<RequireAuth><NewPackingOperations /></RequireAuth>} />
      <Route path="/new-packing-operations" element={<RequireAuth><NewPackingOperations /></RequireAuth>} />

      <Route path="/boms" element={<RequireAuth><ProcessingRecipesList /></RequireAuth>} />
      <Route path="/boms/add" element={<RequireAuth><CreateBOM /></RequireAuth>} />
      <Route path="/boms/edit/:id" element={<RequireAuth><EditBOM /></RequireAuth>} />
      <Route path="/boms/:id" element={<RequireAuth><ProcessingRecipeDetail /></RequireAuth>} />

      <Route path="/batches" element={<RequireAuth><ProcessBatchList /></RequireAuth>} />
      <Route path="/batch/:batchId" element={<RequireAuth><BatchDetailsPage /></RequireAuth>} />

      <Route path="/plants" element={<RequireAuth><PlantList /></RequireAuth>} />
      <Route path="/plants/:id" element={<RequireAuth><PlantView /></RequireAuth>} />
      <Route path="/machines" element={<RequireAuth><MachineList /></RequireAuth>} />
      <Route path="/machines/:id" element={<RequireAuth><MachineView /></RequireAuth>} />

      <Route path="/production-requests" element={<RequireAuth><ProductionRequestList /></RequireAuth>} />
      <Route path="/production-requests/create" element={<RequireAuth><ProductionRequestWizard /></RequireAuth>} />
      <Route path="/production-requests/:id" element={<RequireAuth><ProductionRequestDetail /></RequireAuth>} />

      <Route path="/inventory" element={<RequireAuth><InventoryData /></RequireAuth>} />
      <Route path="/inventory/:id" element={<RequireAuth><InventoryDetail /></RequireAuth>} />
      <Route path="/stock-overview" element={<RequireAuth><StockOverview /></RequireAuth>} />

      <Route path="/stock" element={<RequireAuth><StockOverview /></RequireAuth>} />
      <Route path="/stock/product/:productId" element={<RequireAuth><ProductStockDetails /></RequireAuth>} />
      <Route path="/stock-transfer" element={<RequireAuth><NewStockTransfer /></RequireAuth>} />
      <Route path="/stock/add-existing" element={<RequireAuth><AddExistingStock /></RequireAuth>} />

      {/* Stock Transfer routes removed - using only instances */}

      <Route path="/stock-transfer-instances" element={<RequireAuth><StockTransferInstanceList /></RequireAuth>} />
      <Route path="/stock-transfer-instances/create" element={<RequireAuth><StockTransferInstanceCreate /></RequireAuth>} />
      <Route path="/stock-transfer-instances/:id" element={<RequireAuth><StockTransferInstanceDetails /></RequireAuth>} />

      <Route path="/settings/company" element={<RequireAuth><CompanySettings /></RequireAuth>} />

      <Route path="/notifications" element={<RequireAuth><Notifications /></RequireAuth>} />

      <Route path="/reports" element={<RequireAuth><Reports /></RequireAuth>} />
      <Route path="/reporting-dashboard" element={<RequireAuth><ReportingDashboard /></RequireAuth>} />

      <Route path="/inactive-status" element={<InactiveStatus />} />

      <Route path="/logout" element={null} />
    </Routes>
  );
};

export default RoutesConfig;
